import { type GeneralParticipationInfoApiResponse } from '~/features/general-participation/types/general-participation'
import {
  type TicketDetailApiResponse,
  type TicketDetailResponse,
  type TicketTypeListApiResponse,
  type TicketTypeListResponse,
} from '~/features/ticket/types/ticket'
import { END_POINTS, get } from '~/shared/http-client/api'

export const getShopEventId = async (): Promise<number> => {
  const response: GeneralParticipationInfoApiResponse = await get(
    END_POINTS.generalParticipationInfo.shop,
  )

  const shopEventId = response.data.shop_info.event_id

  return shopEventId
}

export const getTicketTypeList = async (
  eventId: number,
): Promise<TicketTypeListResponse> => {
  const response: TicketTypeListApiResponse = await get(
    `${END_POINTS.generalParticipationInfo.ticket}/${eventId}`,
  )

  return response.data
}

export const getTicketDetailByEventTicketId = async (
  eventTicketId: number,
): Promise<TicketDetailResponse> => {
  const response: TicketDetailApiResponse = await get(
    `${END_POINTS.generalParticipationInfo.ticketDetail}/${eventTicketId}`,
  )

  return response.data
}
